module.exports = __webpack_public_path__ + "img/m_4.cbb7801e.png";